module.exports = __webpack_public_path__ + "img/topics.dcffaecb.png";